import React from "react";
// import "./ProfileProgress.scss";

interface ProfileProgressProps {
  firstName: string;
  progress: number;
}

export const ProfileProgress: React.FC<ProfileProgressProps> = ({
  firstName,
  progress,
}) => {
  return (
    <div className="profile-progress">
      <div className="progress-info">
        <h3>
          {firstName}, your profile is {progress}% complete.
        </h3>
        <p>
          Fill out your profile to unlock personalized insights and attract
          partners.
        </p>
      </div>
      <div className="progress-bar">
        <div className="progress-fill" style={{ width: `${progress}%` }}></div>
      </div>
    </div>
  );
};
